// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federstahldraht/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federstahldrahtDE: PageEntry = {
  id: "post.federstahldraht",
  locale: "de",
  slug: "federstahldraht",
  seo: {
    title: "Federstahldraht: Werkstoffe und Einsatz | Dietz GmbH",
    description:
      "Federstahldraht im Überblick: Werkstoffe, Eigenschaften und Einsatzgebiete in der industriellen Federfertigung. Sprechen Sie uns an.",
  },
  type: "post",
  h1: "Glossar: Federstahldraht einfach erklärt",
  intro: "Federstahldraht ist ein spezieller Draht, der für die Herstellung von Federn verwendet wird. Dieser Draht zeichnet sich durch hohe Festigkeit, Elastizität und Biegsamkeit aus. Häufig besteht Federstahldraht aus legiertem Stahl, um optimale mechanische Eigenschaften zu gewährleisten. Die Auswahl des richtigen Federstahldrahts ist entscheidend für die Leistung und Zuverlässigkeit von Federn in verschiedenen Anwendungen, von Fahrzeugfederungen bis zu industriellen Maschinen.",
  blocks: [

  ],
};
